import { useMemo } from 'react'
import { GridOptions, SuppressKeyboardEventParams } from 'ag-grid-community'
import {
  columnTypes,
  defaultOnCellClicked,
  frameworkComponents,
} from '../../../containers/commons/AgGrid'
import { DefaultCellRenderer } from '../../../containers/BulkSheetView/components/cellRenderer'
import { intl } from '../../../../i18n'
import { ProgramManagementRow } from '../programManagement'
import { ProgramItemTreeCellRenderer } from '../components/ProgramItemTreeCellRenderer'
import { useColumnDefs } from './columnDefs'

export const useProgramManagementGridOptions =
  (): GridOptions<ProgramManagementRow> => {
    const columnDefs = useColumnDefs()

    const gridOptions: GridOptions<ProgramManagementRow> = useMemo(
      () => ({
        // ヘッダー・行の高さ
        groupHeaderHeight: 25,
        headerHeight: 45,
        rowHeight: 32,

        // コンテキスト（ページコンポーネントから上書きされる）
        context: {},

        suppressLastEmptyLineOnPaste: true,

        // 行操作
        rowDragManaged: true,
        rowDragMultiRow: true,
        suppressMoveWhenRowDragging: true,
        enterNavigatesVerticallyAfterEdit: true,

        // カラム型・コンポーネント
        columnTypes: columnTypes(),
        components: frameworkComponents,
        defaultColGroupDef: { suppressHeaderContextMenu: true },
        defaultColDef: {
          cellDataType: false,
          width: 85,
          editable: false,
          enableValue: false,
          sortable: true,
          resizable: true,
          filter: true,
          floatingFilter: true,
          suppressHeaderMenuButton: true,
          suppressHeaderContextMenu: true,
          suppressSizeToFit: true,
          singleClickEdit: false,
          cellStyle: { justifyContent: 'left' },
          cellRenderer: DefaultCellRenderer,
          onCellClicked: defaultOnCellClicked,
          suppressKeyboardEvent: (params: SuppressKeyboardEventParams) => {
            // 日本語入力中はキーボードイベントを抑制する
            if (params.editing && params.event.isComposing) {
              return true
            }
            return (
              !params.editing &&
              ['Delete', 'Backspace'].includes(params.event.key)
            )
          },
        },
        columnDefs,

        // ツリーデータ
        treeData: true,
        excludeChildrenWhenTreeDataFiltering: true,
        groupDefaultExpanded: -1,
        autoGroupColumnDef: {
          headerName: intl.formatMessage({
            id: 'programManagement.column.name',
          }),
          field: 'displayName',
          editable: false,
          cellRendererParams: {
            suppressCount: true,
            innerRenderer: ProgramItemTreeCellRenderer,
          },
          width: 300,
          pinned: 'left' as const,
        },
        processUnpinnedColumns: () => [],
      }),
      [columnDefs]
    )

    return gridOptions
  }
